import { render, staticRenderFns } from "./PasswordRecovery.vue?vue&type=template&id=4f36c5ea"
import script from "./PasswordRecovery.vue?vue&type=script&lang=ts"
export * from "./PasswordRecovery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports